import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmComponent } from './confirm/confirm.component';
import { DialogModule } from '@syncfusion/ej2-angular-popups';



@NgModule({
  declarations: [ConfirmComponent],
  imports: [
    CommonModule,
    DialogModule
  ],
  exports: [
    ConfirmComponent
  ]
})
export class ConfirmModule { }
